
document.addEventListener("DOMContentLoaded", function() {
  /* ========= core renderer ========= */
  function renderCards(el, text, forcedLen, maskLine) {
    el.innerHTML = "";
    const len = Number(forcedLen || el.getAttribute("data-len") || 0);
    const fillChar = el.getAttribute("data-fill") || " ";
    let str = String(text == null ? "" : text);
    const dt = el.getAttribute("data-text");
    if (dt && el.classList.contains("flap-text") && (text == null)) str = dt;
    if (len > 0) {
      if (str.length > len) str = str.slice(0, len);
      if (str.length < len) str = str + fillChar.repeat(len - str.length);
    }
    const mask = (typeof maskLine === "string") ? maskLine : null;
    for (let i = 0; i < str.length; i++) {
      const span = document.createElement("span");
      const isDot = (str[i] === ".");
      const inPixelMap = !!(mask && mask[i] === "█");
      const isLockedPixel = inPixelMap && (str[i] === "█");
      span.className = isDot ? "solari-card dot-cell" : "solari-card";
      if (inPixelMap) span.classList.add("ascii-target");
      if (isLockedPixel) span.classList.add("ascii-lock");
      if (isLockedPixel) {
        span.innerHTML = "&nbsp;";
      } else {
        span.innerHTML = (str[i] === " ") ? "&nbsp;" : str[i];
      }
      el.appendChild(span);
    }
  }
  /* ========= auto-fit Origin so ETA/NOTES never get clipped ========= */
  function fitOriginCardsToRow() {
    const board = document.getElementById("solariBoardRoot");
    if (!board) return;
    if (window.matchMedia("(max-width: 900px)").matches) {
      board.style.removeProperty("--origin-card-w");
      board.style.removeProperty("--origin-card-space");
      return;
    }
    const row = board.querySelector(".solari-row.data-row");
    if (!row) return;
    const flight = row.querySelector(".col-flight");
    const origin = row.querySelector(".col-origin");
    const eta = row.querySelector(".col-eta");
    const notes = row.querySelector(".col-notes");
    if (!flight || !origin || !eta || !notes) return;
    const len = Number(origin.getAttribute("data-len") || 0);
    if (!len) return;
    const rowW = row.getBoundingClientRect().width;
    const flightW = flight.getBoundingClientRect().width;
    const etaW = eta.getBoundingClientRect().width;
    const notesW = notes.getBoundingClientRect().width;
    const cs = window.getComputedStyle(row);
    const gap = parseFloat(cs.columnGap || "0") || 0;
    const avail = rowW - flightW - etaW - notesW - (gap * 3);
    if (avail <= 0) return;
    const baseSpace = Math.max(1, Math.min(2, parseFloat(getComputedStyle(board).getPropertyValue("--s-card-space")) || 2));
    const originSpace = baseSpace;
    const w = Math.floor((avail - (originSpace * (len - 1))) / len);
    /* ✅ BIG CHANGE: let origin cards grow larger so the board fills width */
    const clampedW = Math.max(12, Math.min(w, 34));
    board.style.setProperty("--origin-card-w", clampedW + "px");
    board.style.setProperty("--origin-card-space", originSpace + "px");
  }
  /* ========= capture base text so restore works ========= */
  document.querySelectorAll(".cardify").forEach(el => {
    if (el.id === "solariDateTime") return;
    if (el.dataset.base != null) return;
    if (el.classList.contains("flap-text")) {
      el.dataset.base = el.getAttribute("data-text") || "";
    } else {
      el.dataset.base = (el.textContent || "").trim();
    }
  });
  /* ========= initial paint ========= */
  document.querySelectorAll(".cardify:not(.flap-text)").forEach(el => {
    renderCards(el, (el.textContent || "").trim(), el.getAttribute("data-len"));
  });
  document.querySelectorAll(".flap-text").forEach(el => {
    renderCards(el, null, el.getAttribute("data-len"));
  });
  fitOriginCardsToRow();
  window.addEventListener("resize", () => {
    clearTimeout(window.__solariFitT);
    window.__solariFitT = setTimeout(fitOriginCardsToRow, 80);
  });
  /* ========= time ========= */
  function updateTime() {
    const now = new Date();
    const options = { weekday: "short", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
    const timeString = now.toLocaleDateString("en-US", options).replace(/,/g, "").toUpperCase();
    const el = document.getElementById("solariDateTime");
    if (!el) return;
    const prev = el.getAttribute("data-prev") || "";
    if (prev !== timeString) {
      el.setAttribute("data-prev", timeString);
      renderCards(el, timeString, el.getAttribute("data-len"));
    }
  }
  updateTime();
  setInterval(updateTime, 60000);
  /* ========= flap ========= */
  const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ";
  function randomString(n) {
    let out = "";
    for (let i = 0; i < n; i++) out += CHARS[Math.floor(Math.random() * CHARS.length)];
    return out;
  }
  function flap(el) {
    const originalRaw = el.getAttribute("data-text") || "";
    const len = Number(el.getAttribute("data-len") || originalRaw.length || 0);
    const fillChar = el.getAttribute("data-fill") || " ";
    let original = String(originalRaw);
    if (len > 0) {
      if (original.length > len) original = original.slice(0, len);
      if (original.length < len) original = original + fillChar.repeat(len - original.length);
    }
    let cycles = 0;
    const interval = setInterval(() => {
      renderCards(el, randomString(len), len);
      cycles++;
      if (cycles > 10) {
        clearInterval(interval);
        requestAnimationFrame(() => renderCards(el, original, len));
      }
    }, 50);
  }
  function restoreAllToBase(board) {
    board.querySelectorAll(".cardify").forEach(el => {
      if (el.id === "solariDateTime") return;
      const len = Number(el.getAttribute("data-len") || 0);
      const base = (el.dataset.base != null) ? el.dataset.base : "";
      renderCards(el, base, len);
    });
    fitOriginCardsToRow();
  }
  /* ========= BUY NOW takeover ========= */
  const BIG_MSG = "BUY NOW";
  const FONT_5 = {
    "B": ["████ ", "█   █", "████ ", "█   █", "████ "],
    "U": ["█   █", "█   █", "█   █", "█   █", " ███ "],
    "Y": ["█   █", " █ █ ", "  █  ", "  █  ", "  █  "],
    "N": ["█   █", "██  █", "█ █ █", "█  ██", "█   █"],
    "O": [" ███ ", "█   █", "█   █", "█   █", " ███ "],
    "W": ["█   █", "█   █", "█ █ █", "██ ██", "█   █"],
    " ": ["   ", "   ", "   ", "   ", "   "]
  };
  function buildAsciiLines(msg, canvasWidth) {
    const up = String(msg || "").toUpperCase();
    const rows = ["", "", "", "", ""];
    const gap = 2;
    for (let k = 0; k < up.length; k++) {
      const ch = FONT_5[up[k]] ? up[k] : " ";
      const g = FONT_5[ch];
      for (let r = 0; r < 5; r++) rows[r] += g[r] + " ".repeat(gap);
    }
    for (let r = 0; r < 5; r++) rows[r] = rows[r].replace(/\s+$/g, "");
    const widthNow = Math.max(...rows.map(r => r.length));
    const padTotal = Math.max(0, canvasWidth - widthNow);
    const padLeft = Math.floor(padTotal / 2);
    const padRight = padTotal - padLeft;
    return rows.map(line => {
      let s = " ".repeat(padLeft) + line + " ".repeat(padRight);
      if (s.length > canvasWidth) s = s.slice(0, canvasWidth);
      if (s.length < canvasWidth) s = s + " ".repeat(canvasWidth - s.length);
      return s;
    });
  }
  function startAsciiTakeover(board, done) {
    const originTargets = Array.from(board.querySelectorAll(".col-origin.cardify")).slice(0, 5);
    if (originTargets.length < 5) { done && done(); return; }
    const canvasWidth = Number(originTargets[0].getAttribute("data-len") || 60);
    const lines = buildAsciiLines(BIG_MSG, canvasWidth);
    const allTargets = Array.from(board.querySelectorAll(".cardify")).filter(el => el.id !== "solariDateTime");
    const nonOriginTargets = allTargets.filter(el =>
      !el.classList.contains("col-origin") &&
      !el.closest(".header-row")
    );
    const TAKEOVER_MS = 5000;
    const EXIT_MS = 650;
    const TICK_MS = 65;
    const REVEAL_RAMP_MS = 1400;
    board.classList.add("ascii-mode");
    const start = performance.now();
    const timer = setInterval(() => {
      const elapsed = performance.now() - start;
      for (const el of nonOriginTargets) {
        const len = Number(el.getAttribute("data-len") || 0);
        if (!len) continue;
        renderCards(el, randomString(len), len);
      }
      if (elapsed >= TAKEOVER_MS) {
        if (elapsed < TAKEOVER_MS + EXIT_MS) {
          for (let r = 0; r < 5; r++) {
            const el = originTargets[r];
            const len = Number(el.getAttribute("data-len") || canvasWidth) || canvasWidth;
            renderCards(el, randomString(len), len);
          }
          return;
        }
        clearInterval(timer);
        board.classList.remove("ascii-mode");
        done && done();
        return;
      }
      const progress = Math.max(0, Math.min(1, elapsed / REVEAL_RAMP_MS));
      for (let r = 0; r < 5; r++) {
        const el = originTargets[r];
        const len = Number(el.getAttribute("data-len") || canvasWidth) || canvasWidth;
        const mask = (lines[r] || "").padEnd(len, " ").slice(0, len);
        const out = new Array(len);
        for (let i = 0; i < len; i++) {
          const isPixelCell = (mask[i] === "█");
          if (isPixelCell) {
            out[i] = (Math.random() < progress) ? "█" : randomString(1);
          } else {
            out[i] = (Math.random() < 0.02) ? " " : ".";
          }
        }
        renderCards(el, out.join(""), len, mask);
      }
    }, TICK_MS);
  }
  function runLoop(board) {
    const NORMAL_HOLD_MS = 5000;
    const SETTLE_HOLD_MS = 5000;
    restoreAllToBase(board);
    board.querySelectorAll(".flap-text").forEach((el, i) => {
      setTimeout(() => flap(el), i * 200);
    });
    setTimeout(() => {
      startAsciiTakeover(board, () => {
        restoreAllToBase(board);
        setTimeout(() => runLoop(board), SETTLE_HOLD_MS);
      });
    }, NORMAL_HOLD_MS);
  }
  const board = document.getElementById("solariBoardRoot");
  if (!board) return;
  let started = false;
  function startOnce() {
    if (started) return;
    started = true;
    runLoop(board);
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        startOnce();
        observer.unobserve(entry.target);
      }
    });
  });
  observer.observe(board);
  setTimeout(() => {
    fitOriginCardsToRow();
    const r = board.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) startOnce();
  }, 80);
});
